import { Component, computed, inject, input } from "@angular/core";

import { ToastService } from "@shared/services/toast/toast.service";

@Component({
  selector: "app-toast",
  templateUrl: "./toast.component.html",
  styleUrl: "./toast.component.scss",
})
export class ToastComponent {
  text = input<string>("");
  icon = input<string>("");
  success = input<boolean>(true);
  dismissButton = input<boolean>(false);
  hasMarginBottom = input<boolean>(false);

  protected toastService = inject(ToastService);
  protected state = computed(() => this.toastService.state());
}
